export const CONTACTS_MOCK: any[] = []

export let currentId = CONTACTS_MOCK.length
